import { doGraphqlRequest } from 'ducks/requests'
import doCreateShopifyEvent from './doCreateShopifyEvent'
import graphql from '../api'
import * as types from '../types'
import { orderPartial } from './partials'

const mutation = `
  mutation refundCreate($input: RefundInput!) {
    refundCreate(input: $input) {
      order {
        ${orderPartial}
      }
      refund {
        id
      }
      userErrors {
        field
        message
      }
    }
  }
`

const restockTypeMap = {
  no_restock: 'NO_RESTOCK',
  cancel: 'CANCEL',
  return: 'RETURN',
}

const doOrderRefund = (integrationId, orderId, data) => async dispatch => {
  const { conversationId } = data

  const variables = {
    input: {
      orderId,
      currency: data.currencyCode,
      note: data.notes,
      notify: data.sendNotification,
      refundLineItems: data.lineItems.map(item => {
        return {
          lineItemId: item.id,
          locationId: item.locationId || null,
          quantity: item.refundQuantity,
          restockType: restockTypeMap[item.restockType] || 'NO_RESTOCK',
        }
      }),
      shipping: {
        amount: data.shippingAmount,
        fullRefund: false,
      },
    },
  }

  if (data.transactionInformation) {
    const parentId = `gid://shopify/OrderTransaction/${
      data.transactionParentId
    }`
    variables.input.transactions = [
      {
        amount: data.transactionAmount,
        gateway: data.transactionGateway,
        kind: 'REFUND',
        orderId,
        parentId,
      },
    ]
  }

  const result = await dispatch(
    doGraphqlRequest(types.ORDER_REFUND_REQUEST, mutation, variables, {
      graphqlFunc: graphql(integrationId),
      moduleOptions: {
        toasts: {
          enabled: true,
          started: {
            enabled: false,
          },
          success: {
            enabled: true,
            content: 'Refund created',
          },
          failed: {
            enabled: true,
            content: 'Refund creation failed',
          },
        },
      },
    })
  )

  if (orderId) {
    dispatch(
      doCreateShopifyEvent(
        integrationId,
        orderId,
        conversationId,
        'ORDER_REFUNDED'
      )
    )
  }

  return result
}

export default doOrderRefund
